import {
  SGPageTemplateContentEntry,
  SGPageTemplateAdZone,
} from '../../../../../src/types/page-templates'

export function isPageTemplateContentEntry(
  value: SGPageTemplateContentEntry | SGPageTemplateAdZone
): value is SGPageTemplateContentEntry {
  return (
    typeof value === 'object' &&
    value != null &&
    '__typename' in value &&
    value.__typename === 'SGPageTemplateContentEntry'
  )
}
